import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2;
import { fontSize, lineHeight } from "../../constants/typography";
import { NeutralColors, UIPalette } from "../../constants/colors";
import mediaQueries from "../../util/mediaqueries";
import { BREAKPOINTS, MEGA_MENU_Z_INDEX, MOBILE_HEADER_HEIGHT } from "../../constants/design";
import styled, { css } from 'styled-components';
import { DISPLAY_TYPE } from "../banner/constants";
import { NavigationContainer } from "../mega-menu/mega-menu.styles";
import { TopMenuList } from "../mega-menu/components/top-menu/top-menu.styles";
export var Banner = styled.div.withConfig({
  componentId: "sc-vaskkr-0"
})(["background-color:", ";color:", ";text-align:center;padding:19px 32px;font-size:", ";line-height:", ";", " & > a{color:", ";text-decoration:underline;font-weight:600;}"], UIPalette.Emerald, NeutralColors.GreyPaper, fontSize.xSmall, lineHeight.medium, mediaQueries.sm(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), 0, 0)), fontSize.small, lineHeight.large), UIPalette.Yellow400);
var bannerPosition = function bannerPosition(displayType) {
  if (displayType === DISPLAY_TYPE.STICKY) return 'sticky';
  return 'relative';
};
var navStyles = function navStyles(_ref, menuHeight) {
  var displayType = _ref.displayType,
    bannerHeight = _ref.bannerHeight;
  if (displayType === DISPLAY_TYPE.FIXED) {
    return css(["top:0;position:sticky;height:0;"]);
  }
  return css(["top:", "px;"], bannerHeight || menuHeight);
};
export var Container = styled.div.withConfig({
  componentId: "sc-vaskkr-1"
})(["position:relative;", "{position:", ";top:0;z-index:", ";}", "{", ";", "}", "{@media (max-width:", "px){top:", "px;}}"], Banner, function (_ref2) {
  var displayType = _ref2.displayType;
  return bannerPosition(displayType);
}, MEGA_MENU_Z_INDEX + 1, NavigationContainer, function (props) {
  return navStyles(props, 72);
}, mediaQueries.sm(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", ";\n    "])), 0)), function (props) {
  return navStyles(props, 62);
}), TopMenuList, BREAKPOINTS.md - 1, function (_ref3) {
  var bannerHeight = _ref3.bannerHeight;
  return bannerHeight + MOBILE_HEADER_HEIGHT;
});